import React from 'react';
import { BsDownload } from 'react-icons/bs';
import jsonData from './Json';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import "./ViewReport.scss";

const ViewReport = () => {
  const { program } = useParams();

  return (
    <>
      <Helmet>
        <title>{program} Internship Final Year Report | V-Ex Tech Solution</title>
        <meta name="title" content={`${program} internship final year report pdf`} />
        <meta
          name="description"
          content="Download internship final year reports for Data Science, MERN Stack, Full Stack Development, Python, Software Testing and more from V-Ex Tech Solution, Vadodara."
        />
      </Helmet>

      <div className="report-view-wrapper">
        {jsonData.map((item, index) => (
          <div key={index} className="report-section">
            {item.cards
              .filter((card) => card.value === program)
              .map((card, cardIndex) => (
                <div key={cardIndex} className="report-card">
                  <h1 className="report-title">{card.value} Report</h1>
                  <p className="report-desc">
                    Below is your final internship project report. You can view it directly
                    or download it for submission.
                  </p>

                  <a href={card.link} download={card.value} className="download-btn">
                    <BsDownload />
                    Download PDF
                  </a>

                  <div className="pdf-viewer">
                    <embed src={card.link} type="application/pdf" />
                  </div>
                </div>
              ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default ViewReport;
